module.exports = __webpack_public_path__ + "static/img/logo-todomath-for-web-ja@3x.512e86b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo-todomath-for-web-ja@3x.png
// module id = vXfn
// module chunks = 18